"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      diaplay: "flex",
      flex: 1
    },
    loader: {
      color: "green",
      marginLeft: 10
    },
    center: {
      display: "flex",
      alignItems: "center"
    }
  };
});

var Select = function Select(_ref) {
  var handleChange = _ref.handleChange,
      field = _ref.field,
      fieldId = _ref.fieldId,
      defaultValue = _ref.defaultValue,
      label = _ref.label,
      loadingSelect = _ref.loadingSelect,
      handleElements = _ref.handleElements;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      err = _useState2[0],
      setErr = _useState2[1];

  (0, _react.useEffect)(function () {
    if (field.hasError) {
      setErr(true);
    }
  }, [field.hasError]);

  var handleInsideChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var val;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              val = e.target;
              handleElements(function (prevState) {
                return [].concat(_toConsumableArray(prevState), [val]);
              });
              handleChange(fieldId, val.value, "select", val.name, field.label);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleInsideChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var isChild = (0, _react.useMemo)(function () {
    return field.isChild.parentId ? true : false;
  }, [field]);
  var defaultStyles = {};
  var style = !field.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(field.customStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    style: style,
    error: err && defaultValue === "" && !field.allowNull
  }, /*#__PURE__*/React.createElement(_core.InputLabel, null, label), /*#__PURE__*/React.createElement(_core.Select, {
    id: fieldId || "",
    name: field.name,
    value: defaultValue,
    onChange: handleInsideChange,
    disabled: isChild && !field.source.defaultValues.length && !field.allowNull
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "",
    disabled: true
  }, field.placeholder), field.source.defaultValues.map(function (t, i) {
    var value = t.value && t.value.value ? t.value.value : t.value ? t.value : "";
    var label = t.label && t.label.label ? t.label.label : t.label ? t.label : "";
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: "type_".concat(i),
      value: value
    }, label);
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.center
  }, /*#__PURE__*/React.createElement(_core.FormHelperText, null, defaultValue === "" && err ? "Campo requerido" : field.placeholder, " "), loadingSelect[field.name] && /*#__PURE__*/React.createElement(_core.CircularProgress, {
    size: 12,
    className: classes.loader
  }))));
};

var _default = Select;
exports.default = _default;